import api from './api';

const URLS = {
  getStripeCredentials: 'getStripeCredentials',
  createStripePaymentIntent: 'createStripePaymentIntent',
};

export const getStripeCredentials = (propertyId) => {
  return api.post(URLS.getStripeCredentials, { propertyId: propertyId });
};

export const createStripePaymentIntent = (customer, totalAmount, depositAmount, propertyId) => {
  return api.post(URLS.createStripePaymentIntent, {
    ...customer,
    totalAmount: totalAmount,
    depositAmount: depositAmount,
    propertyId: propertyId,
  });
};
